var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('six-modal',{ref:"switchTeamMemberModal",staticClass:"modal",attrs:{"title":"","dismissable":false,"closeButton":false,"backdrop":"blurred"}},[_c('div',{staticClass:"modal-title"},[_vm._v("Switching Account")]),_c('div',{staticClass:"spinner"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }